import { ArrowLeft, ArrowRight, Clock, Mail, Phone, User, MessageCircle, Megaphone, } from "lucide-react";
import { toast } from "sonner";
import Summary from "../components/Summary";

export default function Step5({ data, setData, next, back }) {
  const update = (key, value) => {
    setData({ ...data, [key]: value, });
  };
  const handleNext = () => {
    const requiredFields = [
      {
        key: "name",
        label: "Full Name",
      },
      {
        key: "phone",
        label: "Mobile Number",
      },
      {
        key: "email",
        label: "Email Address",
      },
      {
        key: "whatsapp",
        label: "WhatsApp Number",
      },
      {
        key: "contactTime",
        label: "Preferred Contact Time",
      },
      {
        key: "heardFrom",
        label: "How did you hear about us?",
      },
    ];
    const missingField = requiredFields.find(
      (field) =>
        !data[field.key] ||
        String(data[field.key]).trim() === ""
    );
    if (missingField) {
      toast.error("Please complete all required fields", {
        description: `${missingField.label} is required to continue.`,
      });
      return;
    }
    const phone = String(data.phone).replace(/\D/g, "");
    if (!/^[6-9]\d{9}$/.test(phone)) {
      toast.error("Invalid mobile number", {
        description:
          "Please enter a valid 10-digit Indian mobile number.",
      });
      return;
    }
    const whatsapp = String(data.whatsapp).replace(/\D/g, "");
    if (!/^[6-9]\d{9}$/.test(whatsapp)) {
      toast.error("Invalid WhatsApp number", {
        description:
          "Please enter a valid 10-digit WhatsApp number.",
      });
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(data.email.trim())) {
      toast.error("Invalid email address", {
        description:
          "Please enter a valid email address.",
      });
      return;
    }
    toast.success("Details completed", {
      description:
        "Your contact information has been saved.",
    });
    next();
  };

  return (
    <div className="page-grid with-summary">
      <main className="form-card">
        <h2>5. Your Details</h2>
        <p className="section-subtitle">Please provide your contact details and any additional information. We'll send your quotation and get in touch shortly.</p>
        <h3 className="subheading">Personal Information</h3>
        <div className="field-grid two">
          <label>Full Name <span className="required">*</span>
            <div className="input-icon">
              <User size={18} />
              <input
                type="text"
                placeholder="Enter your full name"
                value={data.name || ""}
                onChange={(e) => update("name", e.target.value)} />
            </div>
          </label>
          <label>Mobile Number <span className="required">*</span>
            <div className="input-icon">
              <Phone size={18} />
              <input
                type="tel"
                inputMode="numeric"
                maxLength={10}
                placeholder="Enter 10-digit mobile number"
                value={data.phone || ""}
                onChange={(e) => update("phone", e.target.value.replace(/\D/g, ""))} />
            </div>
          </label>
          <label>Email Address <span className="required">*</span>
            <div className="input-icon">
              <Mail size={18} />
              <input
                type="email"
                placeholder="Enter your email address"
                value={data.email || ""}
                onChange={(e) => update("email", e.target.value)} />
            </div>
          </label>
          <label>WhatsApp Number <span className="required">*</span>
            <div className="input-icon">
              <MessageCircle size={18} />
              <input
                type="tel"
                inputMode="numeric"
                maxLength={10}
                placeholder="Enter WhatsApp number"
                value={data.whatsapp || ""}
                onChange={(e) => update("whatsapp", e.target.value.replace(/\D/g, ""))} />
            </div>
          </label>
        </div>
        <label className="checkbox">
          <input
            type="checkbox"
            checked={data.whatsappUpdates ?? true}
            onChange={(e) => update("whatsappUpdates", e.target.checked)} />
          <span>Send quotation and updates on WhatsApp</span>
        </label>
        <h3 className="subheading">Additional Information</h3>
        <div className="field-grid two">
          <label>Preferred Contact Time{" "}<span className="required">*</span>
            <div className="input-icon select-wrapper">
              <Clock size={18} />
              <select value={data.contactTime || ""} onChange={(e) => update("contactTime", e.target.value)}>
                <option value="">Select contact time</option>
                <option value="Any time">Any time</option>
                <option value="Morning">Morning</option>
                <option value="Afternoon">Afternoon</option>
                <option value="Evening">Evening</option>
              </select>
            </div>
          </label>
          <label>How did you hear about us?{" "}<span className="required">*</span>
            <div className="input-icon select-wrapper">
              <Megaphone size={18} />
              <select value={data.heardFrom || ""} onChange={(e) => update("heardFrom", e.target.value)}>
                <option value="">Select an option</option>
                <option value="Google Search">Google Search</option>
                <option value="Instagram">Instagram</option>
                <option value="Facebook">Facebook</option>
                <option value="Friend / Referral">Friend / Referral</option>
                <option value="WhatsApp">WhatsApp</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </label>
        </div>
        <label>Special Instructions{" "}<span className="optional">(Optional)</span>
          <textarea
            maxLength={500}
            placeholder="Any special requirements, fragile items, access details or other information we should know?"
            value={data.instructions || ""}
            onChange={(e) => update("instructions", e.target.value)} />
          <small className="character-count">{(data.instructions || "").length}/500</small>
        </label>
        <div className="actions">
          <button type="button" className="back ghost" onClick={back}><ArrowLeft size={17} />Back</button>
          <button type="button" className="primary" onClick={handleNext}>Next: Review & Get Quote<ArrowRight size={18} /></button>
        </div>
      </main>
      <Summary data={data} total={data.services?.length ? 3000 : 0} />
    </div>
  );
}